import sortable from "html5sortable/dist/html5sortable.es";
import apiClient from "../frontend/apiClient";

/* expects each sortable item(each element in the container with the sortable class), to have a data.path pointing to the action to take when an item has been moved. */

let createParameter = (name, value, form) => {
  const parameter = document.createElement('input')
  parameter.setAttribute('name', name)
  parameter.setAttribute('value', `${value}`)
  form.appendChild(parameter)
}

document.addEventListener('DOMContentLoaded', function () {
  const sortableElements = sortable('.sortable', {
    handle: '.sortable-handle',
    placeholder: '<div class="sortable-placeholder" style="height: 0; position: relative; z-index: 1000; border-top: 1px dashed #25252588; margin-top: -1px"></div>'
  })

  for(let sortableElement of sortableElements){
    sortableElement.addEventListener('sortupdate', async function(e) {
      const form = document.createElement('form')
      form.setAttribute('action', e.detail.item.dataset.path)
      form.setAttribute('method', 'post')
      form.style.display = 'none'
      let csrfParam = document.querySelector('meta[name=csrf-param]').getAttribute('content')
      let csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content')
      createParameter('_method', 'put', form)
      createParameter(csrfParam, csrfToken, form)
      createParameter('position', e.detail.destination.index+1, form)
      document.body.appendChild(form)
      form.submit()
      /*
      apiClient.put(e.detail.item.dataset.path, {position: e.detail.destination.index+1})
        .then(()=>{window.location.reload(true)})
        .catch(()=>{window.location.reload(true)})
        */
    });
  }
});
